import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useWorkOrderHideActionsOnTerminalStatusEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.HideCancelActionOnTerminalSrStatus,
    false
  );

  return Boolean(isEnabled);
}
